import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAuth = false, requireNonAnonymous = false }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  // If authentication is required and user is not logged in
  if (requireAuth && !currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If non-anonymous authentication is required and user is anonymous
  if (requireNonAnonymous && currentUser && currentUser.isAnonymous) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 